// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"RM-z","upvoteIcon":"SM-z","downvoteIcon":"TM-z","feedbackIcon":"UM-z"};